module.exports = __webpack_public_path__ + "assets/img/tit6.22ed95ff.png";